package com.patronat.top.features.venues.di

import com.patronat.top.features.venues.data.network.VenuesRemoteDataSource
import com.patronat.top.features.venues.data.repository.VenuesRepositoryImpl
import com.patronat.top.features.venues.domain.repository.VenuesRepository
import com.patronat.top.features.venues.domain.usecase.CreateVenueUseCase
import com.patronat.top.features.venues.domain.usecase.GetFilteredVenuesUseCase
import com.patronat.top.features.venues.domain.usecase.GetSubmittedVenueDraftUseCase
import com.patronat.top.features.venues.domain.usecase.GetVenueAssigneesUseCase
import com.patronat.top.features.venues.domain.usecase.GetVenueByIdUseCase
import com.patronat.top.features.venues.domain.usecase.GetVenueDraftUseCase
import com.patronat.top.features.venues.domain.usecase.ImportVenueWithAiUseCase
import com.patronat.top.features.venues.domain.usecase.PatchVenueDraftUseCase
import com.patronat.top.features.venues.domain.usecase.ReassignVenueModeratorUseCase
import com.patronat.top.features.venues.domain.usecase.ReviewVenueDraftUseCase
import com.patronat.top.features.venues.domain.usecase.UpdateVenueStatusUseCase
import com.patronat.top.features.venues.domain.usecase.UpdateVenueUseCase
import com.patronat.top.features.venues.presentation.VenueFormViewModel
import com.patronat.top.features.venues.presentation.VenuesListViewModel
import org.koin.dsl.module

val venuesFeatureModule = module {
    single { VenuesRemoteDataSource(httpClient = get()) }
    single<VenuesRepository> { VenuesRepositoryImpl(remoteDataSource = get()) }
    single { CreateVenueUseCase(venuesRepository = get(), dispatcherProvider = get()) }
    single { GetFilteredVenuesUseCase(venuesRepository = get(), dispatcherProvider = get()) }
    single { GetSubmittedVenueDraftUseCase(venuesRepository = get(), dispatcherProvider = get()) }
    single { GetVenueAssigneesUseCase(venuesRepository = get(), dispatcherProvider = get()) }
    single { GetVenueByIdUseCase(venuesRepository = get(), dispatcherProvider = get()) }
    single { GetVenueDraftUseCase(venuesRepository = get(), dispatcherProvider = get()) }
    single { ImportVenueWithAiUseCase(venuesRepository = get(), dispatcherProvider = get()) }
    single { PatchVenueDraftUseCase(venuesRepository = get(), dispatcherProvider = get()) }
    single { ReviewVenueDraftUseCase(venuesRepository = get(), dispatcherProvider = get()) }
    single { ReassignVenueModeratorUseCase(venuesRepository = get(), dispatcherProvider = get()) }
    single { UpdateVenueStatusUseCase(venuesRepository = get(), dispatcherProvider = get()) }
    single { UpdateVenueUseCase(venuesRepository = get(), dispatcherProvider = get()) }

    factory<VenueFormViewModel> {
        VenueFormViewModel(
            alertController = get(),
            createVenueUseCase = get(),
            getVenueByIdUseCase = get(),
            getVenueDraftUseCase = get(),
            getSubmittedVenueDraftUseCase = get(),
            getVenueAssigneesUseCase = get(),
            getUserByIdUseCase = get(),
            reassignVenueModeratorUseCase = get(),
            updateVenueUseCase = get(),
            patchVenueDraftUseCase = get(),
            reviewVenueDraftUseCase = get(),
            updateVenueStatusUseCase = get(),
            uploadImageUseCase = get()
        )
    }

    factory<VenuesListViewModel> {
        VenuesListViewModel(
            alertController = get(),
            getFilteredVenuesUseCase = get(),
            importVenueWithAiUseCase = get(),
            updateVenueStatusUseCase = get(),
            getUserByIdUseCase = get()
        )
    }
}
